import Nova from "@/components/mapa/src/components/mapa/stationIcon/moon/Nova.svg";
import Crescente from "@/components/mapa/src/components/mapa/stationIcon/moon/Crescente.svg";
import QuartoCrescente from "@/components/mapa/src/components/mapa/stationIcon/moon/QuartoCrescente.svg";
import GibosaCrescente from "@/components/mapa/src/components/mapa/stationIcon/moon/GibosaCrescente.svg";
import Cheia from "@/components/mapa/src/components/mapa/stationIcon/moon/Cheia.svg";
import GibosaMinguante from "@/components/mapa/src/components/mapa/stationIcon/moon/GibosaMinguante.svg";
import QuartoMinguante from "@/components/mapa/src/components/mapa/stationIcon/moon/QuartoMinguante.svg";
import Minguante from "@/components/mapa/src/components/mapa/stationIcon/moon/Minguante.svg";

const PHASE_BY_API = {
  "new moon":         { label: "Nova",             icon: Nova },
  "waxing crescent":  { label: "Crescente",        icon: Crescente },
  "first quarter":    { label: "Quarto Crescente", icon: QuartoCrescente },
  "waxing gibbous":   { label: "Gibosa Crescente", icon: GibosaCrescente },
  "full moon":        { label: "Cheia",            icon: Cheia },
  "waning gibbous":   { label: "Gibosa Minguante", icon: GibosaMinguante },
  "last quarter":     { label: "Quarto Minguante", icon: QuartoMinguante },
  "waning crescent":  { label: "Minguante",        icon: Minguante },
};

export function moonPhaseInfo(apiPhase, luminosity) {
  if (apiPhase) {
    const hit = PHASE_BY_API[String(apiPhase).trim().toLowerCase()];
    if (hit) return hit;
  }
  if (luminosity == null) return null;
  const lum = Number(luminosity);
  if (lum <= 5)  return { label: "Nova",      icon: Nova };
  if (lum <= 45) return { label: "Crescente", icon: Crescente };
  if (lum <= 65) return { label: "Quarto",    icon: QuartoCrescente };
  if (lum <= 95) return { label: "Gibosa",    icon: GibosaCrescente };
  return { label: "Cheia", icon: Cheia };
}
